import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Zap, Users, ArrowRight } from "lucide-react"; // Optional: npm install lucide-react
import Navbar from "../Navbar/Navbar";
import Footer from "../LandingPage/Footer";
import "./integrationWhatsApp.css";

const IntegrationWhatsApp = () => {
  const navigate = useNavigate();

  const userBotMessage = [
    { user: "Hello", bot: "Hey there! How can I assist you with your order today?" },
    { user: "What is the bot name?", bot: "I am Eagle-QMS, your dedicated AI assistant." },
  ];

  const integrationSteps = [
    { title: "Request", desc: "Submit your WhatsApp integration request through our portal." },
    { title: "Verify", desc: "Meta Business Account creation & verification process." },
    { title: "Approve", desc: "Official WhatsApp Cloud API approval from Meta." },
    { title: "Train", desc: "AI training using your specific business documentation." },
    { title: "Go Live", desc: "Deployment to your official business number." },
  ];
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL;
  const handlegetStarted = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/SignIn");
      return;
    }
    try {
      const userEmail = localStorage.getItem("email"); 
      const res = await fetch(
        `${REACT_APP_BACKEND_URL}/api/auth/get-bots-by-email/${userEmail}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      const botCount = data?.length || 0;
      if (botCount >= 1) {
        navigate("/dashboard");
      } else if (botCount === 0) {
        navigate("/buildChatBot");
      }} catch (error) {
      console.error("Error fetching bots:", error);
      navigate("/buildChatBot");
    }
  };

  return (
    <div className="wa-page-wrapper">
      <div className="wa-navbar-bg">
        <Navbar />
      </div>

      {/* Hero Section */}
      <section className="wa-hero">
        <div className="wa-container wa-hero-grid">
          <div className="wa-hero-content">
            <h1 className="wa-main-title">
              Engage Customers <span className="wa-text-gradient">Everywhere</span> on WhatsApp
            </h1>
            <p className="wa-main-subtitle">
              Automate 80% of support queries with a dedicated AI chatbot.
              Seamlessly transition to human agents when things get complex.
            </p>
            <div className="wa-hero-btns">
              <button className="wa-btn-primary" onClick={handlegetStarted}>
                Get Started Free <ArrowRight size={18} />
              </button>
              <button className="wa-btn-secondary" onClick={() => navigate("/bookdemo")}>
                Book Demo
              </button>
            </div>
            <div className="wa-trust-tags">
              <span>✓ Official Meta Partner</span>
              <span>✓ End-to-End Encryption</span>
            </div>
          </div>

          <div className="wa-hero-visual">
            <div className="wa-phone-frame">
              <div className="wa-phone-screen">
                <div className="wa-phone-header">
                  <div className="wa-phone-user">
                    <div className="wa-avatar-green">X</div>
                    <div>
                      <p className="wa-phone-username">XenaChat Bot</p>
                      <p className="wa-phone-status">Online</p>
                    </div>
                  </div>
                </div>
                <div className="wa-phone-chat">
                  <div className="wa-bubble bot">Hi 👋 How can I help you today?</div>
                  {userBotMessage.map((item, i) => (
                    <React.Fragment key={i}>
                      <div className="wa-bubble user">{item.user}</div>
                      <div className="wa-bubble bot">{item.bot}</div>
                    </React.Fragment>
                  ))}
                </div>
                <div className="wa-phone-input">
                  <div className="wa-input-box">
                    <span className="wa-input-placeholder">Type a message</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="wa-features">
        <div className="wa-container">
          <div className="wa-section-header">
            <span className="wa-section-badge">Capabilities</span>
            <h2>Enterprise-Grade Capabilities</h2>
            <p>Designed to handle millions of conversations with security and intelligence.</p>
          </div>

          <div className="wa-feature-grid">
            <div className="wa-feature-card premium">
              <div className="wa-feature-icon">
                <Zap size={26} />
              </div>
              <h3>AI-Powered Context</h3>
              <p>
                Understands intent, memory, and conversation flow for near-human responses.
              </p>
            </div>

            <div className="wa-feature-card premium">
              <div className="wa-feature-icon secure">
                <ShieldCheck size={26} />
              </div>
              <h3>Enterprise-Level Security</h3>
              <p>
                End-to-end encryption, audit logs, and compliance-ready infrastructure.
              </p>
            </div>

            <div className="wa-feature-card premium">
              <div className="wa-feature-icon hybrid">
                <Users size={26} />
              </div>
              <h3>Smart Human Handoff</h3>
              <p>
                Instantly route chats to live agents without losing conversation context.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="wa-steps">
        <div className="wa-container">
          <div className="wa-section-header">
            <span className="wa-section-badge">Process</span>
            <h2>The Road to Integration</h2>
            <p>A transparent, guided onboarding journey.</p>
          </div>

          <div className="wa-steps-grid">
            {integrationSteps.map((step, index) => (
              <div className="wa-step-card" key={index}>
                <div className="wa-step-circle">{index + 1}</div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final Call to Action */}
      <section className="wa-cta-section">
        <div className="wa-container">
          <div className="wa-cta-box">
            <h2>Ready to scale your customer support?</h2>
            <p>Join over 500+ businesses using Eagle-QMS to drive efficiency.</p>
            <button className="wa-btn-primary large" onClick={() => navigate("/bookdemo")}>Request Integration Now</button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IntegrationWhatsApp;